var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88508 5.69789C7.27729 5.69789 8.4059 4.56928 8.4059 3.17707C8.4059 1.78486 7.27729 0.65625 5.88508 0.65625C4.49287 0.65625 3.36426 1.78486 3.36426 3.17707C3.36426 4.56928 4.49287 5.69789 5.88508 5.69789Z",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40621 13.2604L10.927 18.302H0.84375L3.36457 13.2604V10.7396C3.36457 9.34733 4.49315 8.21875 5.88539 8.21875C7.27757 8.21875 8.40621 9.34733 8.40621 10.7396V13.2604Z",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36426 23.3463V18.3047",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40527 23.3463V18.3047",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9834 23.1703V18.2109",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4583 5.69789C17.8505 5.69789 18.9791 4.56928 18.9791 3.17707C18.9791 1.78486 17.8505 0.65625 16.4583 0.65625C15.0661 0.65625 13.9375 1.78486 13.9375 3.17707C13.9375 4.56928 15.0661 5.69789 16.4583 5.69789Z",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9791 18.302V10.7396C18.9791 9.34733 17.8506 8.21875 16.4583 8.21875C15.0661 8.21875 13.9375 9.34733 13.9375 10.7396V18.302H18.9791Z",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9785 23.3463V18.3047",
    stroke: "#908F98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoedIcon);
export default __webpack_public_path__ + "static/media/coedIcon.f5601aabe2011bf06dd768bd035dff26.svg";
export { ForwardRef as ReactComponent };